import { Button, ButtonRow } from '@ksyos/design-system';
import { ManagerAuthorization } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import { hasOneAuthorization } from '@frontend/utils';
import { ReprocessAction } from './reprocessAction';

interface IPaymentsFooterButtonsProps {
    isDisabled: boolean;
    isReportDisabled: boolean;
    onProcessActivity: (reprocessAction: ReprocessAction) => void;
    onReport: () => void;
}

export function PaymentsFooterButtons(props: IPaymentsFooterButtonsProps) {
    const language = getSelectedLanguage();

    return (
        <ButtonRow>
            {hasOneAuthorization(ManagerAuthorization.financePayoutsEdit) && (
                <>
                    <Button
                        isDisabled={props.isDisabled}
                        onClick={() => props.onProcessActivity(ReprocessAction.reprocess)}
                        variant="outline"
                    >
                        {language.finance.reprocessPayout}
                    </Button>
                    <Button
                        isDisabled={props.isDisabled}
                        onClick={() => props.onProcessActivity(ReprocessAction.unpaid)}
                        variant="outline"
                    >
                        {language.finance.activityUnpaid}
                    </Button>
                    <Button
                        isDisabled={props.isDisabled}
                        onClick={() => props.onProcessActivity(ReprocessAction.paid)}
                        variant="outline"
                    >
                        {language.finance.activityPaid}
                    </Button>
                </>
            )}
            <Button
                isDisabled={props.isReportDisabled}
                onClick={props.onReport}
                variant="outline"
            >
                {language.finance.report}
            </Button>
        </ButtonRow>
    );
}
